import React, { useState, useEffect, useContext } from "react";
// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import {
  Button,
  Calendar,
  InputText,
  InputTextarea,
  classNames,
} from "primereact";
import { confirmDialog } from "primereact/confirmdialog";
import { Carousel } from "primereact/carousel";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { baseLang } from "../../../../../../Base/Lang/BaseLang";
import { getLabel } from "../../../../../../Base/Services/Language/LanguageService";
import { ConfigContext } from "../../../../../../Base/Context/ConfigContext/ConfigContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";

import { ObtenerSiguienteNoIngresoMateriale } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";


const EncabezadoSalidasMateriales = ({
  values,
  handleInputChange,
  habilitar,
  setHabilitar,
  resetForm,
  setIngresoToShow,
  setValues,
  getIngreso,
  agregarNuevaFila,
  eliminarItemDetalle,
  setDetalles,
  agentes,
  areas,
  detalles,
  prioridades,
  setMostrarCarousel,
  mostrarCarousel,
  guardarSalidaMaterial = () => {},
  imagenes = [],
}) => {
  const { userAuth } = useContext(AuthContext);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ingesosRequisa, setIngresosRequisa] = useState(false);
  const [selectedPcs, setSelectedPCs] = useState([]);
  // const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // const [mostrarCarousel, setMostrarCarousel] = useState(true);
  const { config } = useContext(ConfigContext);


  const habilitarComponentes = () => {
    setHabilitar(true);
  };

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA REQUISA MATERIAL
  const getInfoNew = async () => {
    setLoading(true);
    const NIngreso = await ObtenerSiguienteNoIngresoMateriale();
    setNoIngreso(NIngreso);

    const d = {
      IdEstado: 28,
      StatusName: "Creado",
      FechaEnc: new Date(),
      IdRequisaEnc: -100,
      Requisa: NIngreso[0].Requisa,
      Comentarios: "",
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const abrirModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
  };


  const nuevoIngreso = () => {
    confirmDialog({
      message: "Esta seguro que desea crear una nueva Salida",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        resetForm();
        setDetalles([]);
        getInfoNew();
        habilitarComponentes();
        setIngresoToShow(null)
        setMostrarCarousel(false);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  return (
    <div className="form-demo px-3">
      <div className="d-flex flex-column justify-content-center">
        <h4>{getLabel(baseLang, "salidasM", config.language)}</h4>
        <Loader loading={loading} />
        <Card
          contenido={
            <div className="d-flex">
              <div className="col-10">
                {/* --------------------------CAMPOS-----------------------  */}
                <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                  {/* No. Requisa */}
                  <span className="p-inputgroup " style={{ maxWidth: 235 }}>
                    <span className=" field p-float-label">
                      <InputText
                        id="Requisa"
                        name="Requisa"
                        value={values?.Requisa}
                        onChange={handleInputChange}
                        style={{ fontWeight: "bold" }}
                        onKeyDown={(e) =>
                          e.keyCode === 13 ? getIngreso(e) : null
                        }
                      />
                      <label htmlFor="idEncabezado">No. Requisa Material</label>
                    </span>

                    <Button
                      icon="pi pi-search"
                      type="button"
                      className="p-button-info "
                      onClick={() => getIngreso()}
                      tooltip="Buscar Requisa"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                    />
                  </span>

                  {/* Fecha */}
                  <span className="p-float-label">
                    <Calendar
                      id="Fecha"
                      name="FechaEnc"
                      disabled
                      value={values?.FechaEnc}
                      dateFormat="dd/mm/yy"
                      mask="99/99/9999"
                      showIcon
                    />
                    <label htmlFor="Date">Fecha Creación</label>
                  </span>

                  {/* Estado */}
                  <span className=" p-float-label">
                    <InputText
                      id="estado"
                      disabled
                      name="estado"
                      value={values?.StatusName}
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label htmlFor="estado">Estado</label>
                  </span>

                  {/* Usuario */}
                  <span className=" p-float-label">
                    <InputText
                      disabled
                      id="UserCreate"
                      name="UserCreate"
                      readOnly
                      value={values.UserNameCreate || userAuth?.UserName}
                      autoFocus
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label htmlFor="usuario">Usuario Creación</label>
                  </span>

                  <AutoCompleteDropdown
                    enable={false}
                    value={values.UserNameSolicita}
                    items={agentes}
                    field={"UserName"}
                    name={"UserNameSolicita"}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={"Usuario Autorizó"}
                    disabled
                  />

                  <AutoCompleteDropdown
                    enable={false}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    name={"Area"}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={"Area"}
                    disabled
                  />

                  <AutoCompleteDropdown
                    enable={false}
                    name={"Priority"}
                    value={values.Priority}
                    items={prioridades}
                    field={"Priority"}
                    label={"Prioridad"}
                    handleInputChange={handleInputChange}
                    disabled
                  />

                  {/* Comentarios */}
                  <span className=" p-float-label d-flex">
                    <InputTextarea
                      disabled={true}
                      id="Comentarios"
                      name="Comentarios"
                      value={values?.Comentarios}
                      onChange={handleInputChange}
                      cols={86.3}
                      rows={2}
                      className={classNames(" block", "encabezado__contenido")}
                      style={{
                        width: "100%",
                        maxHeight: "3rem",
                        maxWidth: "72vh",
                        height: "3rem",
                      }}
                    />
                    <label
                      id="label_comentario"
                      htmlFor="Comentarios"
                      className={classNames("encabezado__contenido")}
                    >
                      Comentarios
                    </label>
                  </span>
                </div>

                {/* --------------------------BOTONES-----------------------  */}
                {/* <div className="d-flex flex-wrap gap-3 mb-2">
                  <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-5 flex-wrap justify-content-between">
                    <Button
                      icon="pi pi-plus"
                      type="button"
                      className="p-button-info encabezado__herramienta-botones"
                      tooltip="Agregar Items"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={!habilitar}
                      onClick={(e) => {
                        agregarNuevaFila();
                      }}
                      tabIndex={7}
                    />
                    <Button
                      icon="pi pi-save"
                      className="p-button-primary encabezado__herramienta-botones"
                      tooltip="Guardar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={!habilitar}
                      style={{ marginLeft: 1 }}
                      onClick={(e) => {
                        guardarSalidaMaterial();
                      }}
                    />
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      className="p-button-secondary  encabezado__herramienta-botones"
                      onClick={habilitarComponentes}
                      tooltip="Editar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                    />
                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger encabezado__herramienta-botones"
                      onClick={() => eliminarItemDetalle()}
                      tooltip="Cancelar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={!habilitar}
                      style={{ marginLeft: 1 }}
                    />
                    <Button
                      icon="pi pi-sync"
                      type="button"
                      className="p-button-info encabezado__herramienta-botones"
                      onClick={() => getIngreso()}
                      tooltip="Cargar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                    />
                  </div>
                </div> */}
              </div>

              {mostrarCarousel && (
                <div
                  className="col-2 d-flex"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                    }}
                  >
                    {imagenes.CodigoProducto && (
                      <Carousel
                        value={imagenes.img}
                        circular
                        showIndicators={false}
                        itemTemplate={(item) => {
                          return (
                            <div
                              className="d-flex"
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                              }}
                            >
                              <img
                                src={"data:image/png;base64," + item}
                                alt="imagen"
                                onClick={() => abrirModal(item)}
                                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", cursor: "pointer" }}
                              />
                            </div>
                          );
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>

      {/* Dialogo para mostrar imagenes */}
      <Dialog header={detalles ? detalles[0]?.NombreProducto : ""} visible={showModal} onHide={cerrarModal} className="w-50">
        <div
          style={{
            maxWidth: "100%",
          }}
        >
          {imagenes.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default EncabezadoSalidasMateriales;
